import  { useEffect, useState } from "react";
import {  socketFunc } from "../../../../utils/socketUtil";
// import useAuthStore from "@/store/auth";
import {  useParams } from "react-router-dom";
import qs from "qs";
import { Toaster } from "../../../../utils/toaster";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";

const IGPixel = () => {
  const { provider } = useParams();
  const token = localStorage.getItem("token");
  const socket = socketFunc(token);
  const [iframeUrl, setIframeUrl] = useState("");
  const disableFooter = window?.screen?.width > 767 ? false : true;
  useEffect(() => {
    const decodedParams = decodeURIComponent(window.location.href);
    const parsedValues = qs.parse(decodedParams.split("?")?.[1] || "");
    getLobby(parsedValues);
  }, [provider]);

  const getLobby = (params) => {
    socket.emit(
      "get:sports_lobby",
      {
        providerCode: provider?.toUpperCase(),
        ...params,
      },
      (res) => {
        if (res?.status === "failed") {
          Toaster.Error(res?.message || "Failed to get");
        }
        if (res?.status === "success") {
          handleResponse(res);
        }
      }
    );
  };

  const handleResponse = (value) => {
    if (value?.data && typeof value?.data === "string") {
      setIframeUrl(value?.data);
    } else if (value?.data && "lobbyUrl" in value?.data?.data) {
      setIframeUrl(value?.data?.data?.lobbyUrl);
    } else {
      setIframeUrl("");
    }
  };

  return (
    <div>
      <HeaderAfterLogin />
      <div className="container-with-leftbar no-footer">
        <div className="main-wrapper">
          <iframe
            src={iframeUrl}
            isRedirectionRequired={false}
            style={{
              width: "100%",
              height: "calc(100vh - 50px)",
            }}
          />

          <div>{/* <BottomNav /> */}</div>
        </div>
      </div>
    </div>
  );
};
export default IGPixel;
